function handleErrorLog(error: string) {
  if (process.env.NODE_ENV === "development") {
    console.log(error);
  }
}

export default handleErrorLog;
